"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TargetType = void 0;
var TargetType;
(function (TargetType) {
    TargetType[TargetType["None"] = 0] = "None";
    TargetType[TargetType["All"] = 1] = "All";
    TargetType[TargetType["AllButSelf"] = 2] = "AllButSelf";
    TargetType[TargetType["Self"] = 3] = "Self";
    TargetType[TargetType["Any"] = 4] = "Any";
    TargetType[TargetType["AllAllies"] = 100] = "AllAllies";
    TargetType[TargetType["OneAllies"] = 101] = "OneAllies";
    TargetType[TargetType["TwoAllies"] = 102] = "TwoAllies";
    TargetType[TargetType["ThreeAllies"] = 103] = "ThreeAllies";
    TargetType[TargetType["FourAllies"] = 104] = "FourAllies";
    TargetType[TargetType["OneCompanion"] = 105] = "OneCompanion";
    TargetType[TargetType["AllCompanions"] = 106] = "AllCompanions";
    TargetType[TargetType["AllAllyCompanions"] = 107] = "AllAllyCompanions";
    TargetType[TargetType["AllEnemyCompanions"] = 108] = "AllEnemyCompanions";
    TargetType[TargetType["AllEnemies"] = 200] = "AllEnemies";
    TargetType[TargetType["OneEnemies"] = 201] = "OneEnemies";
    TargetType[TargetType["TwoEnemies"] = 202] = "TwoEnemies";
    TargetType[TargetType["ThreeEnemies"] = 203] = "ThreeEnemies";
    TargetType[TargetType["FourEnemies"] = 204] = "FourEnemies";
    TargetType[TargetType["InFront"] = 300] = "InFront";
    TargetType[TargetType["Behind"] = 301] = "Behind";
    TargetType[TargetType["AllDeadAllies"] = 400] = "AllDeadAllies";
    TargetType[TargetType["OneDeadAllies"] = 401] = "OneDeadAllies";
    TargetType[TargetType["TwoDeadAllies"] = 402] = "TwoDeadAllies";
    TargetType[TargetType["ThreeDeadAllies"] = 403] = "ThreeDeadAllies";
    TargetType[TargetType["FourDeadAllies"] = 404] = "FourDeadAllies";
    TargetType[TargetType["AllDeadEnemies"] = 500] = "AllDeadEnemies";
    TargetType[TargetType["OneDeadEnemies"] = 501] = "OneDeadEnemies";
    TargetType[TargetType["TwoDeadEnemies"] = 502] = "TwoDeadEnemies";
    TargetType[TargetType["ThreeDeadEnemies"] = 503] = "ThreeDeadEnemies";
    TargetType[TargetType["FourDeadEnemies"] = 504] = "FourDeadEnemies";
    TargetType[TargetType["LastAttackedBy"] = 600] = "LastAttackedBy";
})(TargetType = exports.TargetType || (exports.TargetType = {}));
